import { createBusinessComponent } from '../utils/create';
import Popup from '../mixins/popup'; // TODO: 后续需要优化 应该移除 dateHelper

import '@tujia/fe-lib-common/lib/third-libs/g.date.js';
import '@tujia/fe-lib-common/lib/third-libs/date-helper.js';
var GDate = window.GDate;
export default createBusinessComponent({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('transition', {
      attrs: {
        "name": "tj-slide-up"
      }
    }, [_vm.shouldRender ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.value,
        expression: "value"
      }],
      class: _vm.b()
    }, [_c('div', {
      staticClass: "tj-calendar-g"
    }, [_c('div', {
      staticClass: "tj-calendar-content",
      style: {
        top: _vm.options.marginTop || 0
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('div', {
      staticClass: "header",
      on: {
        "touchmove": function touchmove($event) {
          $event.preventDefault();
        }
      }
    }, [_c('div', {
      staticClass: "header-close"
    }, [_c('img', {
      staticClass: "close-icon",
      attrs: {
        "src": "https://pic.tujia.com/upload/festatic/publicImages/calendar-close.png",
        "alt": "close"
      },
      on: {
        "click": _vm.close
      }
    }), _c('span', {
      staticClass: "close-btn",
      on: {
        "click": _vm.clearSelectedDays
      }
    }, [_vm._v("清空")])]), !_vm.options.hideHeader ? _c('div', {
      staticClass: "header-content"
    }, [_c('div', {
      staticClass: "header-content-list"
    }, [_vm.isSelectedBeginDate ? [_c('div', {
      staticClass: "list-item"
    }, [_vm._v(_vm._s(_vm.dateText.begin) + "日期")]), _c('div', {
      staticClass: "list-item"
    }, [_c('span', {
      staticClass: "list-item-date"
    }, [_vm._v(_vm._s(_vm.dateBeginEndMD('begin')))]), _c('span', {
      staticClass: "list-item-week"
    }, [_vm._v(_vm._s(_vm.dateBeginEndMD('begin', true)))])])] : _c('div', {
      staticClass: "list-item-none"
    }, [_vm._v(_vm._s(_vm.dateText.begin) + "日期")])], 2), _vm.shortCustomDays ? _c('div', {
      staticClass: "header-list-day"
    }, [_c('span', {
      staticClass: "list-day-txt"
    }, [_vm._v("共" + _vm._s(_vm.dayPopupTextInfo.selectedDaysCount ? _vm.dayPopupTextInfo.selectedDaysCount : 0) + "晚")])]) : _c('div', {
      staticClass: "header-list-day"
    }, [_c('span', {
      staticClass: "list-day-txt"
    }, [_vm._v("共" + _vm._s(_vm.dayPopupTextInfo.selectedDaysCount ? _vm.dayPopupTextInfo.selectedDaysCount - 1 : 0) + "晚")])]), _c('div', {
      staticClass: "header-content-list"
    }, [_vm.isSelectedEndDate ? [_c('div', {
      staticClass: "list-item"
    }, [_vm._v(_vm._s(_vm.dateText.end) + "日期")]), _c('div', {
      staticClass: "list-item"
    }, [_c('span', {
      staticClass: "list-item-date"
    }, [_vm._v(_vm._s(_vm.dateBeginEndMD('end')))]), _c('span', {
      staticClass: "list-item-week"
    }, [_vm._v(_vm._s(_vm.dateBeginEndMD('end', true)))])])] : _c('div', {
      staticClass: "list-item-none"
    }, [_vm._v(_vm._s(_vm.dateText.end) + "日期")])], 2)]) : _vm._e()]), _c('div', {
      staticClass: "m-week",
      on: {
        "touchmove": function touchmove($event) {
          $event.preventDefault();
        }
      }
    }, _vm._l(['日', '一', '二', '三', '四', '五', '六'], function (week) {
      return _c('span', {
        key: week,
        class: {
          'isWeekend': (week === '日' || week === '六') && _vm.isCustomStyle
        }
      }, [_vm._v(_vm._s(week))]);
    })), _c('div', {
      ref: "monthGroup",
      class: "g-months " + (_vm.options.hideHeader ? 'hide-header' : '') + " " + (_vm.isCustomStyle ? 'isCustomMonthStyle' : ''),
      on: {
        "scroll": _vm.monthScroll
      }
    }, [_vm._l(_vm.sixMonths, function (item) {
      return _c('tjb-calendar-month', {
        key: item.month,
        ref: "months",
        refInFor: true,
        attrs: {
          "year": item.year,
          "month": item.month,
          "days": item.days,
          "is-price-calendar": _vm.isPriceCalendar,
          "date-text": _vm.dateText,
          "is-open-yesterday": _vm.isOpenYesterday,
          "yesterday-tip": _vm.tips.yesterdayTip,
          "is-show-yesterday-tip": !_vm.isSlelctYesterdayAndNow,
          "is-custom-style": _vm.isCustomStyle,
          "holiday-data": _vm.holidayData,
          "is-show-holiday": _vm.isShowHoliday
        },
        on: {
          "daySelected": _vm.daySelected
        }
      });
    }), _c('div', {
      staticClass: "g-months-tips"
    }, [_vm._v(_vm._s(_vm.bottomTips))])], 2), _c('div', {
      staticClass: "footer"
    }, [_vm.options.quickSelectHoliday ? _c('div', {
      staticClass: "bottom-holiday"
    }, [_c('div', {
      staticClass: "bottom-holiday-title"
    }, [_vm._v("点击节假日，将为您定位并选中节日当天")]), _c('ul', _vm._l(_vm.bottomHolidays, function (item, i) {
      return _c('li', {
        key: "foot-holiday-" + i,
        on: {
          "click": function click($event) {
            _vm.selectHoliday(i);
          }
        }
      }, [_vm._v(_vm._s(item.jrText))]);
    }))]) : _vm._e(), !_vm.isCustomInteraction ? _c('div', {
      staticClass: "bottom-container",
      on: {
        "click": _vm.commit
      }
    }, [_c('transition', {
      attrs: {
        "name": "tj-fade"
      }
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.isOpenYesterday && _vm.isSlelctYesterdayAndNow && _vm.tips.calendarButtonTip,
        expression: "isOpenYesterday && isSlelctYesterdayAndNow && tips.calendarButtonTip"
      }],
      staticClass: "botton-tips"
    }, [_vm._v(_vm._s(_vm.tips.calendarButtonTip))])]), _vm.$slots.bottom ? [_vm._t("bottom")] : _c('div', {
      staticClass: "bottom-container-normal",
      class: {
        'no-active': _vm.noBeginOrEndDateStatus
      }
    }, [_c('span', {
      staticClass: "btn-txt"
    }, [_vm._v(_vm._s(_vm.noBeginOrEndDateStatus || '确定'))])])], 2) : _vm._e()]), _vm.isCustomInteraction && !_vm.isSelectedEndDate && _vm.isSelectedBeginDate ? _c('div', {
      staticClass: "checkTips"
    }, [_vm._v("选择离店日期")]) : _vm._e()])])]) : _vm._e()]);
  },
  name: 'calendar',
  mixins: [Popup],
  props: {
    value: Boolean,
    overlay: {
      type: Boolean,
      default: true
    },
    closeOnClickOverlay: {
      type: Boolean,
      default: true
    },
    // customDays 自定义日期 用来对比
    customDays: {
      type: Array // default:{
      //   y:2016,
      //   m:12,
      //   d:21,
      //   isHouseUnavailable//是否满房
      //   customText:'' //自定义文本
      // }

    },
    // 自定义样式
    customStyle: {
      type: Object // default: {
      //   middle: Object, // 开始和结束中间的日期样式
      //   default: Object, // 未选中样式
      //   active: Object // 开始和结束日期样式
      // }

    },
    // 短数组自定义日期格子
    shortCustomDays: {
      type: Array // default: {
      //   date: Date,
      //   customText: '',
      //   isBlankSpace: Boolean,
      //   isBooking: Boolean,
      //   toast: string
      // }

    },
    options: {
      type: Object,
      required: true // default: {
      //   beginDate: Date, // 传入日期的时分秒必须为0
      //   endDate: Date,
      //   isCheckBooking: false,
      //   isHaiwai: false,
      //   marginTop: 0, // 顶部间距
      //   singleDay: false, // 是否允许单选一个日期
      //   hideHeader: false, // 是否隐藏头部入离日期模块
      //   beginText: '',
      //   endText: '',
      //   quickSelectHoliday: false //是否显示快捷假日选择区域
      // }

    },
    // 是否打开昨天房子可选开关
    isOpenYesterday: {
      type: Boolean,
      default: false
    },
    // 相关日历提示
    tips: {
      type: Object,
      default: function _default() {
        return {
          yesterdayTip: "\u82E5\u4ECA\u66680\u70B9-6\u70B9\u5165\u4F4F\uFF0C\u8BF7\u9009\u62E9" + new Date().addDays(-1).toString('MM-dd') + "\u65E5",
          // 昨日日期提示
          calendarButtonTip: '入住时间为凌晨0:00后，离店时间为今天12:00' // 日历按钮提示

        };
      }
    },
    // 是否是带价格的日历
    isPriceCalendar: {
      type: Boolean,
      value: false
    },
    // 是否是有底部暗纹，周末颜色区别
    isCustomStyle: {
      type: Boolean,
      default: false
    },
    // 是否展示班休,节假日名称与日期同时展示
    isShowHoliday: {
      type: Boolean,
      default: false
    },
    // 是否开启选择日期后直接确定
    isCustomInteraction: {
      type: Boolean,
      default: false
    },
    // 班休数据
    holidayData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 限制日历日期的数据和开关
    limitData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      sixMonths: [],
      selectedDays: [],
      selectedMonth: {},
      fullMonthScreenHeight: 0,
      parentTopOffset: 0,
      dayPopupTextInfo: {
        selectedDaysCount: 0
      },
      today: null,
      // 快捷假日选择数据
      bottomHolidaysMap: {}
    };
  },
  computed: {
    isSlelctYesterdayAndNow: function isSlelctYesterdayAndNow() {
      var length = this.selectedDays.length;
      var nowDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
      return this.isOpenYesterday && length >= 2 && this.selectedDays[0].date.equals(nowDate.clone().addDays(-1)) && this.selectedDays[length - 1].date.equals(nowDate);
    },

    /**
     * 入离日期的文案配置
     */
    dateText: function dateText() {
      return {
        begin: this.options.beginText || '入住',
        end: this.options.endText || '离店'
      };
    },

    /**
     * 是否选中开始日期
     */
    isSelectedBeginDate: function isSelectedBeginDate() {
      var beginDate = this.selectedDays.find(function (item) {
        return item.isBegin;
      });
      return !!beginDate;
    },

    /**
     * 是否选中离店日期
     */
    isSelectedEndDate: function isSelectedEndDate() {
      var endDate = this.selectedDays.find(function (item) {
        return item.isEnd;
      });
      return !!endDate || this.options.singleDay && this.isSelectedBeginDate;
    },

    /**
     * 入住/离店 日期的 月、日
     */
    dateBeginEndMD: function dateBeginEndMD() {
      var weekArr = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
      return function (type, isweek) {
        if (isweek === void 0) {
          isweek = false;
        }

        if (!this.selectedDays.length) return '';

        if (type === 'begin') {
          var beginDate = this.selectedDays.find(function (item) {
            return item.isBegin;
          });
          if (!beginDate) return '';
          var curMonth = beginDate.date.getMonth() + 1;
          var curDay = beginDate.date.getDate();
          var curWeek = beginDate.date.getDay();
          return isweek ? weekArr[curWeek] : curMonth + "\u6708" + curDay + "\u65E5";
        } else if (type === 'end') {
          var endDate = this.selectedDays.find(function (item) {
            return item.isEnd;
          }); // 支持单选的情况下，结束日期默认为开始日期

          if (this.options.singleDay && !endDate) {
            var tempEnd = this.selectedDays.find(function (item) {
              return item.isBegin;
            });

            var _curMonth2 = tempEnd.date.getMonth() + 1;

            var _curDay2 = tempEnd.date.getDate();

            var _curWeek2 = tempEnd.date.getDay();

            return isweek ? weekArr[_curWeek2] : _curMonth2 + "\u6708" + _curDay2 + "\u65E5";
          }

          if (!endDate) return '';

          var _curMonth = endDate.date.getMonth() + 1;

          var _curDay = endDate.date.getDate();

          var _curWeek = endDate.date.getDay();

          return isweek ? weekArr[_curWeek] : _curMonth + "\u6708" + _curDay + "\u65E5";
        }
      };
    },

    /**
     * 不带价格的日历未选择入离日期时的判断
     */
    noBeginOrEndDateStatus: function noBeginOrEndDateStatus() {
      if (this.options.singleDay) {
        return null;
      }

      if (!this.isSelectedBeginDate || !this.isSelectedEndDate) {
        return !this.isSelectedBeginDate ? "\u8BF7\u9009\u62E9" + this.dateText.begin + "\u65E5\u671F" : "\u8BF7\u9009\u62E9" + this.dateText.end + "\u65E5\u671F";
      }

      return null;
    },

    /**
     * 是否需要加载上一个月日历
     */
    isNeedPrevMonth: function isNeedPrevMonth() {
      var currentDate = new Date();
      var prevDate = currentDate.clone().addDays(-1);
      return this.isOpenYesterday && currentDate.getMonth() !== prevDate.getMonth();
    },
    bottomTips: function bottomTips() {
      // TOC-3213 艺龙渠道预订日期限制
      var limitObj = this.limitData;

      if (limitObj != null && limitObj.isLimit) {
        return limitObj.tips;
      } else {
        return "\u5230\u5E95\u4E86\uFF0C\u6700\u957F\u53EF\u4EE5" + (this.dateText.begin ? '选择6个月以内的日期' : '预订6个月以内的房屋');
      }
    },
    bottomHolidays: function bottomHolidays() {
      var _this$options$quickHo,
          _this = this;

      if ((_this$options$quickHo = this.options.quickHolidays) != null && _this$options$quickHo.length) {
        var array = [];
        this.options.quickHolidays.forEach(function (item) {
          var key = GDate.date.format('yyyy-MM-dd', new Date(item.date));
          var curHoliday = _this.bottomHolidaysMap[key];

          if (curHoliday) {
            array.push(curHoliday);
          }
        });
        return array;
      } else {
        return Object.values(this.bottomHolidaysMap);
      }
    }
  },
  watch: {
    isOpenYesterday: {
      immediate: true,
      handler: function handler(newValue, oldValue) {
        if (newValue === oldValue) {
          return;
        }

        var prevDate = new Date().addDays(-1);
        var prevMonth = prevDate.getMonth(); // 需要加载上一个月份

        if (this.isNeedPrevMonth) {
          // sixMonths 中没有上个月
          var sixMonthsHasPrevMonth = this.sixMonths.find(function (v) {
            return v.month === prevMonth;
          });

          if (!sixMonthsHasPrevMonth) {
            // 没有上个月
            var month = prevMonth;
            var year = prevDate.getFullYear();

            var days = this._initMonthDays(year, month);

            this.sixMonths.unshift({
              year: year,
              month: month,
              isSelected: false,
              days: days
            });
          }
        }

        this.initSixMonth();
      }
    },
    'value': function value(newVisible) {
      if (newVisible) {
        this.parentTopOffset = document.body.scrollTop;
        this.initSixMonth();
      }
    },
    customDays: function customDays(newValue) {
      this.setCustomDays();
    },
    shortCustomDays: function shortCustomDays() {
      this.setCustomDays();
    }
  },
  mounted: function mounted() {
    this.initSixMonth();
  },
  methods: {
    _initMonthDays: function _initMonthDays(year, month) {
      var _this2 = this;

      var monthDays = [];
      var daysByMonth = this.getDaysInMonth(year, month); // console.log('daysByMonth', daysByMonth);

      daysByMonth.map(function (i) {
        var jrDate = GDate.date.formatLunar(i.getFullYear(), i.getMonth() + 1, i.getDate());
        var monthDay = {
          date: i,
          isBegin: false,
          isEnd: false,
          isDuring: false,
          isBooking: false,
          isSelectable: false,
          isUnActiveDay: false,
          isBlankSpace: false,
          style: _this2.customStyle && _this2.customStyle[GDate.date.format('yyyy-MM-dd', i)],
          jrText: jrDate.gf || jrDate.cf // 获取公历或者农历,

        };
        monthDays.push(monthDay);

        if (_this2.options.quickSelectHoliday && monthDay.jrText && monthDay.date.getTime() >= new Date().getTime()) {
          _this2.bottomHolidaysMap[GDate.date.format('yyyy-MM-dd', i)] = monthDay;
        }
      });
      return monthDays;
    },

    /**
     * 取消事件 取消日期，关闭面板恢复上个页面的scrollTop
     * close 在 Popup 中已经引入
     */
    // close() {
    //   this.value = false;
    // },

    /**
     * 面板日期选择事件 设置日期状态
     */
    daySelected: function daySelected(day) {
      var _this$shortCustomDays,
          _this3 = this;

      var shortCustomItem = ((_this$shortCustomDays = this.shortCustomDays) == null ? void 0 : _this$shortCustomDays.find(function (item) {
        return item.toast;
      })) || {}; // 1.如果选择开始和结束事件都有或者都没有，则清除选中状态，并添加开始时间设置
      // 2.如果只有开始时间，则设置结束时间并且遍历中间日期设置状态
      // 3.如果有开始时间，但是结束时间小于开始时间，则清除原来的开始时间，并把当前结束时间设置为开始时间
      // 不可选状态

      if (day.isShortCustom && !day.isBooking && day.isBlankSpace) {
        this.$toast(shortCustomItem.toast || day.toast || '');
        return;
      } else if (!day.isSelectable && !day.isEnd) {
        this.$toast(this.shortCustomDays.length ? shortCustomItem.partUnSelectToast : '选择的日期内部分订满，请重新选择');
        return;
      } else {
        // 如果已经选择开始和结束时间，并且结束时间刚好是新点击的开始时间
        if (!day.isBooking && this.selectedDays.length > 1) {
          this.$toast('该日期已满房');
          this.clearSelectedDays();
          this.setSelectedDaysStatus();
          return;
        }
      }

      if (!this.selectedDays.length || this.selectedDays.length > 1) {
        this.clearSelectedDays();
        this.selectedDays.push(day);
      } else if (this.selectedDays.length === 1) {
        var beginDate = this.selectedDays[0].date; // 如果开始时间>结束时间 重置，并设置最后选择为开始时间

        if (beginDate > day.date) {
          this.clearSelectedDays();
          this.selectedDays.push(day);
        } else if (beginDate < day.date) {
          // 遍历月份数组中，只要日期大于开始日期，并且小于结束日期的话，全部都添加进去
          this.setSelectedDaysStatusForMonthDays(this.selectedDays[0].date, day.date); // setTimeout(this.commit, 500)
        }
      } // 重新初始化选中的日期状态


      this.setSelectedDaysStatus();
      this.setDayPopupTextInfo();
      console.log('当前选择的日期:', day); // 点击日历时触发父级事件，便于处理当前点击的日期

      this.$emit('daySelected', day); // 如果开启选择离店日期立即执行commnit开关

      if (this.isCustomInteraction) {
        if (day.isEnd) {
          setTimeout(function () {
            _this3.commit();
          }, 1000);
        }
      }
    },

    /**
     * 提交事件 提交当前选择的日期，如果不符合，则弹出提示框
     */
    commit: function commit() {
      if (!this.selectedDays.length) return;
      var beginDate = this.selectedDays[0].date;
      var endDate = this.selectedDays[this.selectedDays.length - 1].date; // 判断开始和结束日期，不能相同(可单独选择一天的除外)

      if (beginDate === endDate && !this.options.singleDay) {
        return;
      } // 时间不一样才进行触发


      if (!this.options.beginDate.isSameDay(beginDate) || !this.options.endDate.isSameDay(endDate)) {
        this.options.beginDate = beginDate;
        this.options.endDate = endDate; // 同步当前月份，把offset切换到当前月份

        var month = this.options.beginDate.getMonth();
        this.selectedMonth = this.sixMonths.filter(function (i) {
          return i.month === month;
        })[0];
        this.$emit('dateSelectedChuanged', beginDate, endDate, this.selectedMonth);
      }

      console.log("beginDate=" + beginDate.toString('yyyy-MM-dd') + " endDate=" + endDate.toString('yyyy-MM-dd'));
      this.close();
    },

    /**
     * 月份选择面板变更月份事件 重置月份滚动值
     */
    selectedMonthChuanged: function selectedMonthChuanged(isShowPreNextDay) {
      var _this$selectedMonth;

      if (isShowPreNextDay === void 0) {
        isShowPreNextDay = false;
      }

      var selectMonth = this.options.beginDate.getMonth();
      this.selectedMonth = this.sixMonths.filter(function (i) {
        return i.month === selectMonth;
      })[0];
      this.initScrollOffset();
      var monthGroup = this.$refs.monthGroup;

      if (monthGroup && (_this$selectedMonth = this.selectedMonth) != null && _this$selectedMonth.offsetTop) {
        monthGroup.scrollTop = isShowPreNextDay ? this.selectedMonth.offsetTop - 100 : this.selectedMonth.offsetTop;
      }
    },

    /**
     * 月份滚动事件 用来响应式显示当前的月份
     */
    monthScroll: function monthScroll() {
      this.initScrollOffset();
      var monthGroup = this.$refs.monthGroup;

      if (monthGroup) {
        var _this$sixMonths$, _this$sixMonths$2, _this$sixMonths$3, _this$sixMonths$4, _this$sixMonths$5;

        var monthGroupOffset = monthGroup.scrollTop;

        if (monthGroupOffset < ((_this$sixMonths$ = this.sixMonths[1]) == null ? void 0 : _this$sixMonths$.offsetTop)) {
          this.selectedMonth = this.sixMonths[0];
        } else if (monthGroupOffset < ((_this$sixMonths$2 = this.sixMonths[2]) == null ? void 0 : _this$sixMonths$2.offsetTop)) {
          this.selectedMonth = this.sixMonths[1];
        } else if (monthGroupOffset < ((_this$sixMonths$3 = this.sixMonths[3]) == null ? void 0 : _this$sixMonths$3.offsetTop)) {
          this.selectedMonth = this.sixMonths[2];
        } else if (monthGroupOffset < ((_this$sixMonths$4 = this.sixMonths[4]) == null ? void 0 : _this$sixMonths$4.offsetTop)) {
          this.selectedMonth = this.sixMonths[3];
        } else if (monthGroupOffset < ((_this$sixMonths$5 = this.sixMonths[5]) == null ? void 0 : _this$sixMonths$5.offsetTop)) {
          this.selectedMonth = this.sixMonths[4];
        } else {
          var _this$sixMonths;

          // TOC-3213 艺龙渠道预订日期限制（现在最多是6个月，当加了限制的情况赋值给最后一个）
          var limitObj = this.limitData;
          var arrLength = (_this$sixMonths = this.sixMonths) == null ? void 0 : _this$sixMonths.length;

          if (limitObj != null && limitObj.isLimit && arrLength) {
            this.selectedMonth = this.sixMonths[arrLength - 1];
          } else {
            this.selectedMonth = this.sixMonths[5];
          }
        }
      }
    },

    /**
     * 全局初始化 从这个月开始的六个月时间，并设置选中的日期，以及当前月份和滚动到月份的状态
     */
    initSixMonth: function initSixMonth() {
      var _this4 = this;

      var currentDate = new Date();
      var year = currentDate.getFullYear();
      var month = currentDate.getMonth();

      if (this.sixMonths.length <= 1) {
        var sixMonths = [];

        for (var i = 0; i < 6; i++) {
          var days = this._initMonthDays(year, month);

          sixMonths.push({
            year: year,
            month: month,
            isSelected: false,
            days: days
          }); // 年底重置

          if (month === 11) {
            year++;
            month = 0;
          } else {
            month++;
          }
        }

        this.sixMonths = this.sixMonths.concat(sixMonths); // TOC-3213 艺龙渠道预订日期限制

        var limitObj = this.limitData;

        if (limitObj != null && limitObj.isLimit) {
          this.sixMonths = this.sixMonths.filter(function (item) {
            return item.year === limitObj.limitStartYear || item.year === limitObj.limitEndYear && item.month <= limitObj.limitMonth;
          });
        }
      } // 设置自定义日期的一些文本


      this.setCustomDays(); // 如果外部不设置开始时间和结束时间，则默认前两个时间

      if (!this.options.beginDate) {
        if (this.options.isHaiwai) {
          this.options.beginDate = currentDate.clone().addDays(1);
        } else {
          this.options.beginDate = currentDate.clone();
        }

        this.options.endDate = this.options.beginDate.clone().addDays(1);
      } // 设置从开始时间到结束时间 的日期 添加到 SelectedDays


      this.setSelectedDaysStatusForMonthDays(this.options.beginDate, this.options.endDate); // 为SelectedDays 设置状态

      this.setSelectedDaysStatus(); // 计算当前的日期天数

      this.setDayPopupTextInfo(); // 同步当前月份，把offset切换到当前月份

      this.$nextTick(function () {
        // 滚动到选择日历的位置，如果可选上月最后一天 并且当前初始第一天是下月第一天 就滚动到昨日日期可选位置
        _this4.selectedMonthChuanged(_this4.isNeedPrevMonth && Date.equals(_this4.options.beginDate, currentDate));

        _this4.shortCustomDays && _this4.options.quickSelectHoliday && _this4.clearSelectedDays();
      }, 100);
    },

    /**
     * 初始化 当前各个月份的Offset
     */
    initScrollOffset: function initScrollOffset() {
      var _this$sixMonths2;

      // TOC-3213 艺龙渠道预订日期限制（现在最多是6个月，当加了限制的情况赋值给最后一个）
      var limitObj = this.limitData;
      var arrLength = (_this$sixMonths2 = this.sixMonths) == null ? void 0 : _this$sixMonths2.length;
      var monthsIndex = 5;

      if (limitObj != null && limitObj.isLimit && arrLength) {
        monthsIndex = arrLength - 1;
      }

      if (this.fullMonthScreenHeight === 0 && this.$refs.monthGroup && this.$refs.months && this.$refs.months[monthsIndex]) {
        this.fullMonthScreenHeight = this.$refs.monthGroup.offsetHeight - this.$refs.months[monthsIndex].$el.offsetHeight;
        var offset = 0;

        for (var i = 0; i < this.sixMonths.length; i++) {
          this.sixMonths[i].offsetTop = offset;
          offset += this.$refs.months[i].$el.offsetHeight;
        }
      }
    },

    /**
     * 根据开始日期以及结束日期，设置选中的所有日期
     */
    setSelectedDaysStatusForMonthDays: function setSelectedDaysStatusForMonthDays(beginDate, endDate) {
      if (this.selectedDays.length) {
        // 如果是已经存在了多个选择日期 则重置当前日期
        this.clearSelectedDays();
      }

      var beginMonth = this.sixMonths.filter(function (i) {
        return i.month === beginDate.getMonth();
      })[0];
      var endMonth = this.sixMonths.filter(function (i) {
        return i.month === endDate.getMonth();
      })[0];
      var beginMonthIndex = this.sixMonths.indexOf(beginMonth);
      var endMonthIndex = this.sixMonths.indexOf(endMonth); // 没找到 返回

      if (beginMonthIndex === -1 || endMonthIndex === -1) {
        return;
      }

      for (var i = beginMonthIndex; i <= endMonthIndex; i++) {
        var currentMonth = this.sixMonths[i];

        for (var j = 0; j < currentMonth.days.length; j++) {
          var dayItem = currentMonth.days[j];

          if (dayItem.date >= beginDate && dayItem.date <= endDate) {
            this.selectedDays.push(dayItem);
          }

          if (dayItem.date >= endDate) {
            break;
          }
        }
      } // beginDate.equals(endDate.clone().addDays(-1));

    },

    /**
     * 设置自定义日期的状态，比如是否满房，以及自定义显示文本
     * @type {Boolean}
     */
    setCustomDays: function setCustomDays() {
      var _this5 = this;

      var sixMonthsDays = [];
      this.sixMonths.forEach(function (m) {
        m.days.forEach(function (d) {
          d.customText = undefined;
          d.bookPrice = 0;
          sixMonthsDays.push(d);
        });
      });

      var _loop = function _loop(i) {
        var day = sixMonthsDays[i];

        if (!_this5.options.isCheckBooking && _this5.shortCustomDays) {
          day.isBooking = true;
          day.customText = '';
          day.isBlankSpace = false;

          if (day.isShortCustom) {
            day.isShortCustom = false;
            day.style && (day.style = undefined);
          }

          var j = _this5.shortCustomDays.findIndex(function (item) {
            return GDate.date.format('yyyy-MM-dd', item.date) === GDate.date.format('yyyy-MM-dd', day.date);
          });

          if (j > -1) {
            day.isBooking = _this5.shortCustomDays[j].isBooking;
            day.customText = _this5.shortCustomDays[j].customText;
            day.isBlankSpace = _this5.shortCustomDays[j].isBlankSpace;
            day.isShortCustom = true;

            if (typeof _this5.shortCustomDays[j].style === 'object') {
              day.style = _this5.shortCustomDays[j].style;
            }
          }
        } else if (!_this5.options.isCheckBooking) {
          day.isBooking = true;
        } else if (_this5.customDays && _this5.customDays[i]) {
          day.isBooking = _this5.customDays[i].isBooking;
          day.customText = _this5.customDays[i].customText;
          day.bookPrice = _this5.customDays[i].price;

          if (typeof _this5.customDays[i].style === 'object') {
            day.style = _this5.customDays[i].style;
          }
        } else {
          day.isBooking = false;
        }

        if (_this5.options.quickSelectHoliday) {
          var k = _this5.options.quickHolidays.findIndex(function (item) {
            return GDate.date.format('yyyy-MM-dd', new Date(item.date)) === GDate.date.format('yyyy-MM-dd', day.date);
          });

          if (k > -1) {
            day.jrText = _this5.options.quickHolidays[k].name;
            _this5.bottomHolidaysMap[GDate.date.format('yyyy-MM-dd', day.date)] = day;
          }
        }
      };

      for (var i = 0; i < sixMonthsDays.length; i++) {
        _loop(i);
      }
    },

    /**
     * 设置当前选中的日期状态
     */
    setSelectedDaysStatus: function setSelectedDaysStatus() {
      var isAllBooking = true;

      if (this.customStyle) {
        for (var key in this.customStyle) {
          this.$set(this.customStyle[key], 'disabled', false);
        }
      }

      for (var i = 0; i < this.selectedDays.length; i++) {
        var day = this.selectedDays[i];

        if (i === 0) {
          day.isBegin = true;
        } else if (i === this.selectedDays.length - 1) {
          day.isEnd = true;
        } else {
          day.isDuring = true;
        } // 记录非预订问题


        if (!day.isBooking && i !== this.selectedDays.length - 1) {
          isAllBooking = false;
          break;
        } // 如果开始日期或者结束日期不在自定义范围内，则不使用自定义样式


        if (this.customStyle && this.selectedDays.length >= 2) {
          var beginStr = GDate.date.format('yyyy-MM-dd', this.selectedDays[0].date);
          var endStr = GDate.date.format('yyyy-MM-dd', this.selectedDays[this.selectedDays.length - 1].date);
          var dateStr = GDate.date.format('yyyy-MM-dd', day.date);

          if ((!this.customStyle[beginStr] || !this.customStyle[endStr]) && this.customStyle[dateStr]) {
            this.customStyle[dateStr].disabled = true;
          }
        }
      } // 选择的日期存在非预订的情况，则重置为满房子


      if (!isAllBooking) {
        this.clearSelectedDays();
      } // 处理所有日期 isSelectable 状态 只有一个开始日期的情况，并且之后日期 第一个不可预订存在情况下，把第一个设置为可选择状态，之后所有都设置为不可选状态


      this.canBookingAfterTheFristNoHouseDayStatus();
    },

    /**
     * 处理所有日期 isSelectable 状态 只有一个开始日期的情况
     * 并且之后日期 第一个不可预订存在情况下，把第一个设置为可选择状态，之后所有都设置为不可选状态
     */
    canBookingAfterTheFristNoHouseDayStatus: function canBookingAfterTheFristNoHouseDayStatus() {
      var _this6 = this;

      var isSelectable = true;
      this.sixMonths.forEach(function (m) {
        m.days.forEach(function (d) {
          if (_this6.selectedDays.length === 1 && d.date > _this6.selectedDays[0].date && !d.isBooking) {
            d.isSelectable = isSelectable;
            isSelectable = false;
          } else {
            d.isSelectable = isSelectable && d.isBooking;
          }
        });
      });
    },

    /**
     * 清空当前选中日期的选中状态
     */
    clearSelectedDays: function clearSelectedDays() {
      this.selectedDays.map(function (i) {
        i.isBegin = false;
        i.isEnd = false;
        i.isDuring = false;
      });
      this.selectedDays = []; // 清空所有选择状态

      this.canBookingAfterTheFristNoHouseDayStatus();
      this.setDayPopupTextInfo();
    },

    /**
     * 获取月份中的所有天数
     */
    getDaysInMonth: function getDaysInMonth(year, month) {
      var date = new Date(year, month, 1);
      var days = [];

      while (date.getMonth() === month) {
        days.push(new Date(date));
        date.setDate(date.getDate() + 1);
      } // TOC-3213 艺龙渠道预订日期限制


      var limitObj = this.limitData;

      if (limitObj != null && limitObj.isLimit) {
        if (month === limitObj.limitMonth) {
          days = days.splice(0, limitObj.limitDay);
        }
      }

      return days;
    },

    /**
     * 计算当前的入住天数
     */
    setDayPopupTextInfo: function setDayPopupTextInfo() {
      this.dayPopupTextInfo.selectedDaysCount = 0;

      if (this.selectedDays.length === 1) {
        this.dayPopupTextInfo.selectedDaysCount = 1;
      } else if (this.selectedDays.length > 1) {
        this.dayPopupTextInfo.selectedDaysCount = this.selectedDays.length;
      }
    },
    selectHoliday: function selectHoliday(index) {
      var selectDate = this.bottomHolidays[index];
      var selectMonth = this.sixMonths.find(function (item) {
        return item.month === selectDate.date.getMonth();
      }); // 清除掉之前选择过的

      this.clearSelectedDays();
      this.daySelected(selectDate);
      this.$refs.monthGroup.scrollTop = selectMonth.offsetTop;
    }
  }
});